const Bugsnag = {

    init() {
        window.bugsnagClient = window.bugsnag({
            apiKey: 'a90d715f2f9765b28a5610749c0f4277',
            releaseStage: document.querySelector('meta[name=environment]').content,
            notifyReleaseStages: ['staging', 'production'],
        })
    }
}

module.exports = Bugsnag



// WEBPACK FOOTER //
// ./resources/js/services/Bugsnag.js